import { Icon } from "@kyan/ui";
import React from "react";

import { formatCurrency } from "#/utils/valueFormatters";

interface EquityChangeProps {
  equity: number;
  finalAmount: number;
}

export const EquityChange: React.FC<EquityChangeProps> = ({
  equity,
  finalAmount,
}) => {
  return (
    <div className="flex items-center gap-1">
      <span>
        {formatCurrency(equity, {
          trailingZeroDisplay: "stripIfInteger",
        })}
      </span>
      {finalAmount !== equity && (
        <>
          <Icon size="xs" name="arrow-up" className="rotate-90" />
          <span>
            {formatCurrency(finalAmount, {
              trailingZeroDisplay: "stripIfInteger",
            })}
          </span>
        </>
      )}
    </div>
  );
};
